// extracted by mini-css-extract-plugin
export var active = "side-menu-module--active--8f262";
export var blur = "side-menu-module--blur--98196";
export var cssAnimation = "side-menu-module--cssAnimation--3d60c";
export var languageSelectorContainer = "side-menu-module--languageSelectorContainer--738b1";
export var sideMenu = "side-menu-module--sideMenu--9112f";
export var sideNav = "side-menu-module--sideNav--d048f";